import { NgModule, Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GlobalModule } from '@global/global.module';
import { Relation } from '@app/relation/relation.model';

@Component({
	selector: 'relation-display',
	standalone: false,
	template: /*html*/`
		@if (label) {
			<label>{{label}}</label>
		}
		@if (
			!value.magasins.length
			&& !value.groupes.length
			&& !value.utilisateurs.length
			&& showEmptyLabel
			&& emptyLabel
		) {
			<span>{{emptyLabel}}</span>
		}
		@if (value && value.groupes.length) {
			<div>
				@if (showLabels) {
					<span>Groupes : </span>
				}
				@for (groupe of value.groupes; track groupe) {
					<small class="relation relation-groupe-utilisateur">{{groupe.label}}</small>
				}
			</div>
		}
		@if (value && value.utilisateurs.length) {
			<div>
				@if (showLabels) {
					<span>Collaborateurs : </span>
				}
				@for (utilisateur of value.utilisateurs; track utilisateur) {
					<small class="relation relation-utilisateur">{{utilisateur.label}}</small>
				}
			</div>
		}
		@if (value && value.magasins.length) {
			<div>
				@if (showLabels) {
					<span>Magasins : </span>
				}
				@for (magasin of value.magasins; track magasin) {
					<small class="relation relation-magasin">{{magasin.label}}</small>
				}
			</div>
		}
	`,
	providers: [],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class RelationDisplayComponent {

	@Input() value!: Relation;
	@Input() label: string = '';
	@Input() emptyLabel: string = '—';
	@Input() showEmptyLabel: boolean = false;
	@Input() showLabels: boolean = false;


	constructor() {

	}

}


@NgModule({
	imports: [
		CommonModule,
		GlobalModule
	],
	exports: [RelationDisplayComponent],
	declarations: [RelationDisplayComponent]
})
export class RelationDisplayModule { }
